import { defineStore } from 'pinia'
import { ref } from 'vue'

export const loadingPinia = defineStore('loadingPinia', () => {
  const loading = ref<boolean>(false)
  function toggleLoading(status = false) {
    loading.value = status
  }
  return { loading, toggleLoading }
})
